module.exports = __webpack_public_path__ + "img/cn-login-logo.b0d810a0.png";